<template>
    <div class="grid-content">
        <div class="grid-item grid-item-full">
            <draggable
                :list="fieldsList"
                v-bind="draggableOptions"
                @end="commitSort"
                tag="ol"
                class="list list-group list-divided">
                <li
                    v-for="(field, index) in fieldsList"
                    :data-index="index"
                    :field-value="field.value"
                    :key="`${field.value}-${index}`"
                    @click="() => moveFieldToBottom(index)"
                    class="list-item cursor-pointer align-items-center">
                    <span class="no-flex inline-s drag-handle">
                        <v-icon-button
                            type="basic"
                            class="cursor-move"
                            size="small">
                            <v-icon icon="drag"/>
                        </v-icon-button>
                    </span>
                    <span class="list-item-content inline-l">
                        <span class="display-flex align-items-center">
                            <span>{{(index + 1)}}.&nbsp;</span>
                            <v-separated :list="field.pathLabel" class="display-flex align-items-center"/>
                        </span>
                    </span>
                    <span class="no-flex">
                        <v-icon-button
                            type="basic"
                            size="small"
                            @click.prevent.stop="() => deleteField(index)">
                        <v-icon icon="trash"/>
                    </v-icon-button>
                    </span>
                </li>
            </draggable>

        </div>
        <div
            class="grid-item grid-item-half grid-item-break-half">
            <r-button type="link" @click="showFieldsModal">More Fields</r-button>
        </div>
        <fields-list-modal
            isVisible
            :available-fields="availableFields"
            :default-fields="defaultFields"
            :fields="fields"
            v-if="isFieldsModalVisible"
            @close="closeFieldsModal"
            @update="update"/>
    </div>
</template>
<script>
    import draggable from 'vuedraggable';
    import draggableDefaults from '@/vendor/draggable/defaults';
    import _ from '@/common/helpers';
    import {vIcon, vIconButton} from '@/components/form';
    import vSeparated from '@/components/v-separated';
    import FilterSet from '@/components/query/filter-set';
    import FieldsListModal from '@/modules/data-exports/components/fields-list-modal';

    export default {
        name: 'fields-form',
        components: {
            vIcon,
            vIconButton,
            FieldsListModal,
            vSeparated,
            draggable,
        },
        props: {
            validate: {
                type: Object,
                required: true,
            },
            // all available resource fields
            availableFields: {
                type: Array,
                required: true,
            },
            // model fields
            fields: {
                type: Array,
                required: true,
            },
            defaultFields: Array,
        },
        data() {
            return {
                isFieldsModalVisible: false,
                draggableFields: this.fields.slice(0),
                draggableOptions: draggableDefaults,
            };
        },
        computed: {
            fieldsList() {
                return this.draggableFields.map((field) => {
                    const pathLabel = field
                        .split(FilterSet.delimiter)
                        .map(_.unCamelCase);
                    return {
                        value: field,
                        pathLabel,
                    };
                });
            },
        },
        methods: {
            update(fields) {
                this.$emit('update', fields);
            },
            commitSort({newIndex, oldIndex}) {
                const fields = this.draggableFields.slice(0);
                const field = fields[oldIndex];
                fields.splice(oldIndex, 1);
                fields.splice(newIndex, 0, field);
                this.update(fields);
            },
            deleteField(index) {
                const fields = this.draggableFields.slice(0);
                fields.splice(index, 1);
                this.update(fields);
            },
            moveFieldToBottom(index) {
                const fields = this.draggableFields.slice(0);
                const field = fields[index];
                fields.splice(index, 1);

                if (index === fields.length) {
                    fields.splice(index - 1, 0, field);
                } else {
                    fields.splice(index + 1, 0, field);
                }
                this.update(fields);
            },
            showFieldsModal() {
                this.isFieldsModalVisible = true;
            },
            closeFieldsModal() {
                this.isFieldsModalVisible = false;
            },
        },
        watch: {
            fields(fields) {
                this.draggableFields = fields.slice(0);
            },
        },
    };
</script>
